export default "__VITE_ASSET__JMoOtsR$__"